/**
 * PRODUCT INQUIRY FIELD
 * ---------------------------------------------------------------------------
 * Pole "Produkt, ktorego dotyczy zapytanie" w formularzu kontaktowym:
 * uzytkownik wpisuje fraze, dostaje podpowiedzi z calego katalogu i wybiera
 * produkt z listy (albo wpisuje wlasny tekst - pole zostaje zwyklym inputem).
 *
 * Po wybraniu produktu do formularza trafia dodatkowe, ukryte pole z linkiem
 * do produktu, zeby w mailu byl klikalny adres, a nie sama nazwa.
 *
 * Zrodlo podpowiedzi: Section Rendering API na predictive search
 *   /search/suggest?q=...&resources[type]=product&section_id=product-inquiry-results
 *
 * Bez JS pole dziala jak zwykly input tekstowy - formularz nigdy sie nie blokuje.
 */
(function () {
  'use strict';

  var instanceCount = 0;

  function debounce(fn, wait) {
    var timer = null;

    return function () {
      var context = this;
      var args = arguments;

      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  function absoluteUrl(path) {
    if (!path) return '';
    if (path.indexOf('http') === 0) return path;
    return window.location.origin + path;
  }

  function init(root) {
    if (root.dataset.productInquiryInit) return;
    root.dataset.productInquiryInit = 'true';

    var input = root.querySelector('input[type="text"]');
    var panel = root.querySelector('[data-product-inquiry-panel]');
    var linkField = root.querySelector('[data-product-inquiry-link]');
    var skuField = root.querySelector('[data-product-inquiry-sku]');
    var status = root.querySelector('[data-product-inquiry-status]');
    var picked = root.querySelector('[data-product-inquiry-picked]');
    var pickedThumb = root.querySelector('[data-product-inquiry-picked-thumb]');
    var pickedTitle = root.querySelector('[data-product-inquiry-picked-title]');
    var pickedMeta = root.querySelector('[data-product-inquiry-picked-meta]');
    var changeButton = root.querySelector('[data-product-inquiry-change]');
    var footerTemplate = root.querySelector('[data-product-inquiry-footer-template]');

    if (!input || !panel) return;

    var searchUrl = root.dataset.searchUrl || '/search/suggest';
    var sectionId = root.dataset.sectionId || 'product-inquiry-results';
    var rootUrl = root.dataset.rootUrl || '/';
    var limit = parseInt(root.dataset.limit, 10) || 6;
    var minChars = parseInt(root.dataset.minChars, 10) || 2;
    var queryParam = root.dataset.param || 'produkt';
    var hideUnavailable = root.dataset.hideUnavailable === 'true';

    var options = [];
    var activeIndex = -1;
    var controller = null;
    var lastQuery = '';

    instanceCount += 1;
    panel.id = panel.id || 'product-inquiry-panel-' + instanceCount;

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', panel.id);
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('spellcheck', 'false');

    function clearSelection() {
      if (linkField) linkField.value = '';
      if (skuField) skuField.value = '';
      root.classList.remove('product-inquiry--picked');
    }

    /* Format waluty bierzemy z Liquid (`shop.money_format`), zeby cena w karcie
       wygladala IDENTYCZNIE jak w podpowiedziach (te renderuje Shopify filtrem `money`).
       Intl dawal inny separator tysiecy niz sklep - drobiazg, ale rzuca sie w oczy. */
    function group(value, thousands) {
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    }

    function formatMoney(cents) {
      if (typeof cents !== 'number' || isNaN(cents)) return '';

      var format = root.dataset.moneyFormat || '{{amount_with_comma_separator}}';
      var whole = Math.floor(Math.abs(cents) / 100).toString();
      var frac = ('0' + (Math.abs(cents) % 100)).slice(-2);

      return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
        switch (token) {
          case 'amount': return group(whole, ',') + '.' + frac;
          case 'amount_no_decimals': return group(whole, ',');
          case 'amount_with_comma_separator': return group(whole, '.') + ',' + frac;
          case 'amount_no_decimals_with_comma_separator': return group(whole, '.');
          case 'amount_with_apostrophe_separator': return group(whole, "'") + '.' + frac;
          case 'amount_no_decimals_with_space_separator': return group(whole, ' ');
          case 'amount_with_space_separator': return group(whole, ' ') + ',' + frac;
          default: return group(whole, '.') + ',' + frac;
        }
      });
    }

    /* Pokazuje wybrany egzemplarz jako karte (miniatura, nazwa, SKU, cena) zamiast pola wyszukiwarki.
       Uzywane w scenariuszu A (wejscie z karty produktu) i B (wybor z podpowiedzi). */
    function showPicked(data) {
      input.value = data.title || '';
      lastQuery = input.value;

      if (linkField) linkField.value = absoluteUrl(data.url || '');
      if (skuField) skuField.value = data.sku || '';

      if (!picked) {
        root.classList.add('product-inquiry--picked');
        return;
      }

      if (pickedThumb) {
        pickedThumb.innerHTML = data.thumb
          ? '<img src="' + data.thumb + '" alt="" loading="lazy" width="48" height="48">'
          : '';
      }
      if (pickedTitle) pickedTitle.textContent = data.title || '';
      if (pickedMeta) {
        var meta = [];
        if (data.sku) meta.push('SKU ' + data.sku);
        if (data.price) meta.push(data.price);
        pickedMeta.textContent = meta.join(' \u00b7 ');
      }

      picked.hidden = false;
      root.dataset.view = 'picked';
      root.classList.add('product-inquiry--picked');
      close();
    }

    /* Powrot do wyszukiwarki - przycisk "zmien" albo wejscie w tryb wklejania linku. */
    function resetToSearch(options) {
      var opts = options || {};
      if (picked) picked.hidden = true;
      root.dataset.view = 'search';
      clearSelection();

      if (!opts.keepValue) input.value = '';
      lastQuery = input.value;

      if (opts.focus !== false) input.focus();
    }

    function close() {
      panel.hidden = true;
      panel.innerHTML = '';
      options = [];
      activeIndex = -1;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }

    function setActive(index) {
      if (!options.length) return;

      if (activeIndex > -1 && options[activeIndex]) {
        options[activeIndex].classList.remove('is-active');
        options[activeIndex].setAttribute('aria-selected', 'false');
      }

      activeIndex = (index + options.length) % options.length;

      var option = options[activeIndex];
      option.classList.add('is-active');
      option.setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', option.id);

      if (option.scrollIntoView) {
        option.scrollIntoView({ block: 'nearest' });
      }
    }

    function pick(option) {
      if (!option) return;

      showPicked({
        title: option.dataset.title || '',
        url: option.dataset.url || '',
        sku: option.dataset.sku || '',
        price: option.dataset.price || '',
        thumb: option.dataset.thumb || ''
      });

      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function render(html) {
      panel.innerHTML = html;

      /* Decyzja produktowa: domyslnie pokazujemy takze egzemplarze sprzedane (z etykieta
         "niedostepny"), bo w vintage to czesty powod zapytania. Ustawienie w bloku pozwala
         je ukryc bez ruszania kodu. */
      if (hideUnavailable) {
        panel.querySelectorAll('[data-available="false"]').forEach(function (node) {
          node.remove();
        });
      }

      if (footerTemplate && footerTemplate.content) {
        panel.appendChild(footerTemplate.content.cloneNode(true));
      }

      options = Array.prototype.slice.call(panel.querySelectorAll('[data-product-inquiry-option]'));

      options.forEach(function (option, index) {
        option.id = panel.id + '-option-' + index;
      });

      activeIndex = -1;
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      input.removeAttribute('aria-activedescendant');

      if (status) {
        status.textContent = options.length
          ? options.length + ' ' + (root.dataset.statusResults || 'podpowiedzi')
          : root.dataset.statusEmpty || '';
      }
    }


    /* --- Wykrywanie linku do produktu w polu wyszukiwarki ---------------------------------
       Klient moze albo wpisac fraze, albo wkleic adres egzemplarza. Obie drogi obsluguje
       to samo pole: jesli wartosc wyglada na adres z /products/<handle>, zamiast szukac
       po nazwie dociagamy produkt wprost i pokazujemy go jako wybrany.
       Dziala tez dla samej sciezki (/products/x), adresu z innej domeny i z ?variant=. */
    function handleFromValue(value) {
      if (!value) return null;

      var text = String(value).trim();
      if (!text || text.indexOf(' ') > -1) return null;

      var match = text.match(/\/products\/([^/?#\s]+)/i);
      if (!match) return null;

      try {
        return decodeURIComponent(match[1]);
      } catch (error) {
        return match[1];
      }
    }

    function variantFromValue(value) {
      var match = String(value || '').match(/[?&]variant=(\d+)/);
      return match ? match[1] : null;
    }

    /* Pobiera produkt po handle i pokazuje go jako wybrany egzemplarz.
       fallback: co pokazac, gdy produktu nie da sie dociagnac (usuniety, zly handle). */
    function selectByHandle(handle, fallback) {
      var data = fallback || {};

      return fetch(rootUrl.replace(/\/$/, '') + '/products/' + encodeURIComponent(handle) + '.js')
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.json();
        })
        .then(function (product) {
          var variants = product.variants || [];
          var variant = null;

          if (data.variantId) {
            variant = variants.filter(function (item) {
              return String(item.id) === String(data.variantId);
            })[0] || null;
          }
          if (!variant) variant = variants[0] || {};

          var image = variant.featured_image || product.featured_image || null;
          var src = image ? (image.src || image) : '';

          showPicked({
            title: product.title || data.title || '',
            url: product.url || '/products/' + product.handle,
            sku: data.sku || variant.sku || '',
            price: formatMoney(typeof variant.price === 'number' ? variant.price : product.price),
            thumb: src ? String(src).replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : ''
          });

          return true;
        })
        .catch(function () {
          /* Produkt usuniety albo zly adres. Nie zostawiamy klienta z pustym polem:
             pokazujemy to, co mamy, a link ladujemy surowy, zeby gemmolog mial czego szukac. */
          if (data.title || data.rawUrl) {
            showPicked({
              title: data.title || data.rawUrl,
              url: data.rawUrl || '',
              sku: data.sku || '',
              price: '',
              thumb: ''
            });
          }

          return false;
        });
    }

    /* Sprawdza, czy w polu jest adres produktu, i jesli tak - wybiera go. */
    function trySelectFromValue(value) {
      var handle = handleFromValue(value);
      if (!handle) return false;

      close();
      selectByHandle(handle, {
        rawUrl: String(value).trim(),
        variantId: variantFromValue(value)
      });

      return true;
    }

    var search = debounce(function () {
      var query = input.value.trim();

      if (query.length < minChars) {
        close();
        return;
      }

      if (controller) controller.abort();
      controller = typeof AbortController === 'function' ? new AbortController() : null;

      var url =
        searchUrl +
        '?q=' +
        encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=' +
        limit +
        '&section_id=' +
        sectionId;

      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (html) {
          if (input.value.trim() !== query) return;
          render(html);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          close();
        });
    }, 250);

    input.addEventListener('input', function () {
      if (input.value !== lastQuery) clearSelection();
      if (trySelectFromValue(input.value)) return;
      search();
    });

    /* Wklejenie adresu obslugujemy od razu, bez czekania na opoznienie wyszukiwarki. */
    input.addEventListener('paste', function (event) {
      var text = event.clipboardData && event.clipboardData.getData('text');
      if (!handleFromValue(text)) return;

      event.preventDefault();
      input.value = String(text).trim();
      clearSelection();
      trySelectFromValue(input.value);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= minChars && panel.hidden && !root.classList.contains('product-inquiry--picked')) {
        search();
      }
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        close();
        return;
      }

      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        if (panel.hidden) {
          search();
          return;
        }

        event.preventDefault();
        setActive(activeIndex + (event.key === 'ArrowDown' ? 1 : -1));
        return;
      }

      if (event.key === 'Enter' && !panel.hidden && activeIndex > -1) {
        event.preventDefault();
        pick(options[activeIndex]);
      }
    });

    panel.addEventListener('mousedown', function (event) {
      var option = event.target.closest ? event.target.closest('[data-product-inquiry-option]') : null;
      if (!option) return;

      event.preventDefault();
      pick(option);
    });

    if (changeButton) {
      changeButton.addEventListener('click', function () {
        resetToSearch();
      });
    }

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) close();
    });

    /* Scenariusz A - wejscie z karty produktu.
       Adres z przycisku „Zapytaj gemmologa" (spec 6.3):
         /pages/gemmolog?product=<nazwa>&handle=<handle>&sku=<sku>
       Wstecznie obslugujemy tez pojedynczy parametr z ustawien bloku (domyslnie „produkt”),
       ktory dziala tak samo, jeśli zawiera handle. Miniature i cene dociagamy z /products/<handle>.js. */
    prefillFromQuery();

    function prefillFromQuery() {
      if (!window.URLSearchParams) return;

      var params = new URLSearchParams(window.location.search);
      var handle = params.get('handle') || params.get(queryParam);
      var title = params.get('product') || '';
      var sku = params.get('sku') || '';

      if (!handle && !title) return;

      /* Bez handle nie mamy czego dociagac - pokazujemy to, co przyszlo w adresie. */
      if (!handle) {
        showPicked({ title: title, sku: sku, url: '', price: '', thumb: '' });
        return;
      }

      selectByHandle(handle, { title: title, sku: sku, variantId: params.get('variant') });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-product-inquiry]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target.querySelectorAll ? event.target : document);
  });
})();
